import React from 'react';
import classNames from 'classnames';
import styles from './field-readonly-comment.module.scss';

type IProps = {
  className?: string;
  label?: string;
};

const FieldReadOnlyCommment: React.FC<IProps> = ({
  children,
  className,
  label = null,
}) => (
  <div>
    {label != null ? (<label className={styles.label}>{label}</label>) : (null)}
    <p
      className={classNames(
        {
          [styles.whiteSpace]: true
        },
        className
      )}
    >
      {children}
    </p>
  </div>
);

export default FieldReadOnlyCommment;
